var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysLoyaltyCards = function SvgSysLoyaltyCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.016 19.545v-3.654H5.084A1.984 1.984 0 0 1 3.1 13.906V5.873a1.983 1.983 0 0 1 1.984-1.982h14.033a1.982 1.982 0 0 1 1.979 1.982v8.034a1.987 1.987 0 0 1-.579 1.402 1.974 1.974 0 0 1-1.4.582H15.01v3.654c0 .145-.057.22-.14.22a.308.308 0 0 1-.19-.099l-2.668-1.529-2.675 1.53a.3.3 0 0 1-.188.099c-.079 0-.133-.076-.133-.22Zm3.494-2.273 1.5.861V9h-4v9.133l1.5-.861a.985.985 0 0 1 .995 0h.005Zm2.5-2.381h4.1a.982.982 0 0 0 .98-.985V9h-5.08v5.89Zm-10.915-.985a.988.988 0 0 0 .984.985H9.01V9H4.095v4.905Zm16-5.9V5.877a.98.98 0 0 0-.979-.982H5.083a.988.988 0 0 0-.984.982v2.13h16-.004Z"
  })));
};
export default SvgSysLoyaltyCards;